/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { styled, css, useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery, Box } from '@mui/material';

const CardsWrapper = styled(Box)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing(5)};

    ${theme.breakpoints.up('sm')} {
      flex-direction: row;

      > div:first-child {
        margin-right: ${theme.spacing(8)};
      }
    }

    > div {
      flex: 1 1 40%;
      margin-bottom: ${theme.spacing(4)};
    }
  `,
);

const TlcReimbursementSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className="blue-links">
      <Typography
        variant={isMobile ? 'h3' : 'h2'}
        color="primary"
        component="h2"
        textAlign={{ sm: 'center' }}
        mt={4}
      >
        La téléconsultation est-elle remboursée ?
      </Typography>
      <Typography textAlign={{ sm: 'center' }} fontSize={{ sm: 18 }}>
        <a
          href="/teleconsultation/article/comment-faire-une-teleconsultation/paiement-et-remboursement-dune-teleconsultation"
          target="_blank"
          rel="noopener"
        >
          La téléconsultation est remboursée
        </a>{' '}
        au même titre qu’une consultation physique.
      </Typography>

      <CardsWrapper>
        <Box>
          <Typography variant="h5" component="h3">
            Remboursement de la consultation en ligne
          </Typography>

          <Typography>
            La consultation en ligne est remboursée à hauteur de 70% par la
            sécurité sociale (hors dépassements d’honoraires), les 30% restants
            étant généralement pris en charge par la complémentaire santé. Pour
            cela, il faut simplement respecter le parcours de soin.
            <br />
            <br />
            Pour toute consultation en lien avec la COVID-19, la consultation
            vidéo est remboursée à hauteur de 100% par l’assurance maladie.
          </Typography>
        </Box>

        <Box>
          <Typography variant="h5" component="h3">
            Téléconsultation gratuite
          </Typography>

          <Typography>
            Dans certains cas, le professionnel de santé peut décider que la
            consultation en ligne sera gratuite, au même titre qu’une
            consultation en physique peut l’être. C’est le cas pour les patients
            en affection longue durée notamment.
            <br />
            <br />
            Une pré autorisation bancaire est bien souvent nécessaire, mais le
            praticien peut très bien choisir de la faire gratuitement et de ne
            pas prélever l’argent au patient.
          </Typography>
        </Box>
      </CardsWrapper>
    </Box>
  );
};

export default TlcReimbursementSection;
